export default __webpack_public_path__ + "locales/eljur.bua.json";